import $ from 'jquery'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'param-personnels',
    components: {},
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            save_loading: false,

            fields: [
                { key: 'nom_prenom', label: 'Nom & Prénom.s' }, { key: 'titre', label: 'Titre' },
                { key: 'roles', label: 'Rôle.s' }, { key: 'actions', label: 'Action.s' }
            ],
            filter: "",
            perPage: 10,
            currentPage: 1,

            personnel: {
                user_id: 0,
                nom: '',
                titre: '',
                email: '',
                role_principal: ''
            },
            email_is_not_valid: false,
            user_is_existe: false,
            is_edit: false,

            all_checked: false,
            one_is_checked: [],
            text_grey: [],

            default_role: '',
            modal_title: 'Nouveau personnel',

            to_be_deleted: {
				id: 0,
				personnel: ''
			},
			is_confirm: false,
			del_loading: false,

            liste_personnel_roles: [],
            selected_user: {}
        }
    },
    computed: {
        liste_roles() {
            return this.$store.getters["liste_roles"];
        },
    },
    mounted() {
        this.refreshListePersonnel()

        this.$store.dispatch('getListeRoles')
    },
    methods: {
        refreshListePersonnel() {
            this.is_loading = true
            store_config.getRolePersonnels().then((response) => {
                this.liste_personnel_roles = response
                if (this.liste_personnel_roles.length > 0) {
                    this.is_empty = false 
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            })
        },

        newUser() {
            this.is_edit = false
            this.modal_title = 'Nouveau personnel'
            this.personnel = {
                user_id: 0,
                nom: '',
                titre: '',
                email: '',
                role_principal: ''
            }
            this.$refs.user_form.reset()
        },

        async savePersonnel() {
            const isValid = await this.$refs.user_form.validate();

            if (!isValid) {
                return;
            }

            if (this.personnel.email != '') {
                if (!this.validEmail(this.personnel.email)) {
                    this.email_is_not_valid = true
                    return;
                }
            }

            let data

            this.save_loading = true
            if (this.is_edit) {
                data = {
                    user_id: this.personnel.user_id,
                    nom: this.personnel.nom,
                    titre: this.personnel.titre,
                    email: this.personnel.email,
                    role_principal: this.personnel.role_principal.role_id,
                    role_secondaires: this.one_is_checked
                }
            } else {
                data = {
                    user_id: this.personnel.user_id,
                    nom: this.personnel.nom,
                    titre: this.personnel.titre,
                    email: this.personnel.email,
                    role_principal: this.personnel.role_principal.role_id
                }
            }

            this.$store.dispatch('saveUser', data).then((response) => {
                if (response > 0) {
                    this.refreshListePersonnel()

                    this.$refs.user_form.reset()
                    this.$refs.modal_user.click()
                } else if (response < 0) {
                    this.user_is_existe = true
                }

                this.save_loading = false
            })
        },

        clearError() {
            this.user_is_existe = false
            this.email_is_not_valid = false
        },

        edit(data) {
            this.one_is_checked = []
            this.is_edit = true

            this.personnel = {
                user_id: data.id,
                nom: data.name,
                titre: data.titre,
                email: data.email
            }
            this.modal_title = data.nom

            data.roles.forEach((el) => {
                if (el.pivot.is_default == '1') {
                    this.personnel.role_principal = {
                        role_id: el.id,
                        role_description: el.description
                    }
                    this.default_role = el.description
                } else {
                    this.one_is_checked.push(el.id)
                }
            });
        },

        toutSelectionner() {
            let is_checked = $('#rl-tous').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                let i = 0
                this.liste_roles.forEach((data) => {
                    this.text_grey[i] = 'text-grey'
                    if (data.role_description != this.default_role) {
                        this.one_is_checked.push(data.role_id)
                    }
                    

                    i++
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false

                let i = 0
                this.liste_roles.forEach(() => {
                    this.text_grey[i] = ''
                    i++
                });
            }
        },

        onOneChange(index) {
            let is_checked = $('#rl'+index).is(":checked")

            let c = ''
            if (is_checked == true) {
                c = 'text-grey'
            }
            this.text_grey[index] = c

            document.getElementById("rl-tous").checked = false;
        },

        setToDelete(p) {
            this.to_be_deleted = {
                id: p.id,
                personnel: p.name
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteUser', this.to_be_deleted).then((response) => {
                if (response > 0) {
                    this.successToast("Personnel supprimé avec succès")
                    this.refreshListePersonnel()

                    this.is_confirm = false
                    this.$refs.del_pers.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },

        getCode(data) {
            this.selected_user = data
            $('.view-code').modal('show')
        }
    }
}


